import React from 'react';

import { CheckboxGroup } from 'src/components/molecules/CheckboxGroup/CheckboxGroup';
import type { FacetOptionsProps } from './types';
import { formatOptionCount } from './utils/formatOptionCount';

const onChange = (
  ev: React.ChangeEvent<HTMLInputElement>,
  facet: FacetOptionsProps['facet'],
  onFacetOptionChange: FacetOptionsProps['onFacetOptionChange'],
) => {
  const changedCheckboxValue = ev.target.value;
  const option = facet.options.find((option) => option.value === changedCheckboxValue);

  if (option) {
    onFacetOptionChange({
      key: facet.key,
      title: facet.title,
      options: [
        {
          ...option,
          active: !option.active,
          value: changedCheckboxValue,
        },
      ],
    });
  }
};

export const FacetOptionsMulti = ({ facet, onFacetOptionChange }: FacetOptionsProps) => {
  return (
    <CheckboxGroup
      accessibleLabel={facet.title}
      checkboxData={facet.options.map(({ active, count, title, value }) => ({
        checked: active,
        disabled: !active && count === 0,
        labelText: title,
        value: value as string,
        secondaryLabelText: formatOptionCount(count),
      }))}
      hideLabel
      name={facet.key}
      onChange={(e) => onChange(e, facet, onFacetOptionChange)}
    />
  );
};
